<template>
	<ui-card>
		<ui-title class="has-text-white mb-4">Frågor</ui-title>
		<ui-tabs v-model="activeTab" :tabs="tabs"/>
		<ui-tab>
			<ui-table
				ref="dataTable"
				service="roundHistoryQuestion"
				method="getRoundHistoryQuestions"
				rowHoverEffect
				:headers="headers"
				:queryParams="getQueryParams"
				@rowClick="e => $emit('rowClick', e)"
				:activeTab="activeTab"
			/>
		</ui-tab>
	</ui-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	props: {
		customerId: {
			type: String,
			default: ''
		}
	},

	data: vm => ({
		headers: [{
			text: 'Inventarie',
			value: 'name'
		}, {
			text: 'Brist',
			value: 'answerDescription'
		}, {
			text: 'Hittad',
			value: 'created',
			sortable: true,
			transform: val => vm.$utils.date.getFullDate(val)
		}, {
			text: 'Rond',
			sortable: true,
			value: 'roundPlanningName'
		}],

		tabs: [{
			key: 'toHandle',
			label: 'Att Hantera',
			icon: 'fa-sticky-note'
		}, {
			key: 'done',
			label: 'Åtgärdade',
			icon: 'fa-check'
		}, {
			key: 'all',
			label: 'Alla',
			icon: 'fa-align-left'
		}],

		activeTab: 'toHandle'
	}),

	computed: {
		...mapGetters('user', ['getActiveCustomer', 'getActiveBuilding']),

		getQueryParams() {
			const filter = {};

			if (this.activeTab === 'toHandle') {
				filter.done = false;
				filter.response = false;
			}

			if (this.activeTab === 'done') {
				filter.done = true;
			}

			return {
				customerId: this.customerId,
				buildingId: this.getActiveBuilding.id,
				...filter
			};
		}
	},

	methods: {
		fetchData() {
			this.$refs.dataTable.fetchData();
		}
	}
};
</script>
